import { ReactElement } from 'react';

import { MedicalTreatmentIndications } from '@dreryk/egabinet-discharge-summary-frontend-api';

import { FormContextValues } from '@dreryk/react-common';
import { RadioGroup, RadioGroupItem } from '@dreryk/react-components';

import { dischargeSummaryTranslationKeys } from '../../../../translations';

const items: RadioGroupItem<MedicalTreatmentIndications>[] = [
   {
      id: 'SPECIALIST_CARE_NEEDED',
      label: dischargeSummaryTranslationKeys.furtherMedicalTreatmentGuidelines.values.SPECIALIST_CARE_NEEDED,
   },
   {
      id: 'SPECIALIST_CARE_NOT_NEEDED',
      label: dischargeSummaryTranslationKeys.furtherMedicalTreatmentGuidelines.values.SPECIALIST_CARE_NOT_NEEDED,
   },
   {
      id: 'REFERRAL_FOR_HOSPITALIZATION_ISSUED',
      label:
         dischargeSummaryTranslationKeys.furtherMedicalTreatmentGuidelines.values.REFERRAL_FOR_HOSPITALIZATION_ISSUED,
   },
];

export type FurtherMedicalTreatmentGuidelinesFormBeanPart = {
   furtherMedicalTreatmentGuidelines: MedicalTreatmentIndications | null;
};

type FurtherMedicalTreatmentGuidelinesFieldProps = Pick<
   FormContextValues<FurtherMedicalTreatmentGuidelinesFormBeanPart>,
   'register'
>;

export const FurtherMedicalTreatmentGuidelinesField = (
   props: FurtherMedicalTreatmentGuidelinesFieldProps
): ReactElement => {
   return (
      <RadioGroup
         testId={'furtherMedicalProceduresGuidelinesField'}
         items={items}
         controller={props.register('furtherMedicalTreatmentGuidelines', { required: true })}
      />
   );
};
